import * as d3 from 'd3';

import { resolveFontSizePx } from '#shared';

const innerMetar = resolveFontSizePx(2, 3, innerWidth);
const outerMetar = resolveFontSizePx(5, 7, innerWidth);

export const airportMark = d3.arc()({
  endAngle: Math.PI * 2,
  innerRadius: 1,
  outerRadius: 2,
  startAngle: 0,
}) as string;
export const metarMark = d3.arc()({
  endAngle: Math.PI * 2,
  innerRadius: innerMetar,
  outerRadius: outerMetar,
  startAngle: 0,
}) as string;
